import { useHistory } from 'react-router-dom';

const goToPreviousStep = (stepNumber) => {
  const history = useHistory();
  const nextStep = parseInt(stepNumber, 10) - 1;
  return () =>
    nextStep > 0
      ? history.push(`/register/step-${nextStep}`)
      : history.push('/login');
};

export default goToPreviousStep;
